module.exports = __webpack_public_path__ + "01_short_gold.face53b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_short_gold.png
// module id = 0Oa6
// module chunks = 0